<template>
  
  <div id="surveys">
        <div class="s-main">
            <img src="../../assets/images/icon/ico7.png" alt="">
            <div>提交成功，感谢您的参与！</div>
        </div>
        <div class="delear" v-html="memo">
ddd
        </div>
  </div>
</template>

<script>
export default {
  name: "Surveys",
  created() {
    let me = this;
   
  },
  data() {
    return {
            memo:null,
    }
  },
  async mounted() {
      this.memo=JSON.parse(this.$route.query.memo);
  },
  methods: {
    
    
    
  }
   
   
  
   
}
</script>
<style lang="scss" scoped>
  #app{
    background: #f2f2f2;
    padding-top: 50px;
    height:100%;
}
</style>
<style lang="scss" >
html,body{
    height: 100%;
}

    #surveys{
         padding:100px 50px 50px 50px;
        box-sizing: border-box;
        max-height: 700px;
        background: #fff;
        width: 800px;
        margin: auto;
        overflow: auto;
       
        .s-main{
            text-align: center;
            padding:60px 0;
             border-bottom: 1px solid #ebebeb;
            img{
                width: 60px;height: 60px;margin-bottom: 40px;
            }
            div{font-size: 24px;}
        }
        .delear{font-size: 24px;padding-top: 60px;}
    }
</style>



// WEBPACK FOOTER //
// src/components/Survey/Surveysuccess.vue